import { ClipLoader } from "react-spinners";
import { HeaderStatistic, PersonInfo } from "ui";

import { PersonSummaryProps } from "./PersonSummary.types";

import styles from "./PersonSummary.module.scss";

const PersonSummary = ({
  personImage,
  personFullName,
  personId,
  statistic,
  isLoading,
  nameMarker,
  topElement,
  children
}: PersonSummaryProps) => {
  return (
    <div className={styles.personSummary}>
      {isLoading && (
        <div className={styles.personSummary_loader}>
          <ClipLoader size={50} color="#fb3973" />
        </div>
      )}

      {personFullName && statistic && (
        <>
          <PersonInfo
            image={personImage}
            personName={personFullName}
            topText={topElement}
            bottomText={personId}
            nameMarker={nameMarker}
            wrapperClassName={styles.personSummary_personBlock}
            nameClassName={styles.personSummary_personName}
            dimensions={{ width: 100, height: 100, borderRadius: "100%" }}
          />

          <HeaderStatistic statistic={statistic} />
        </>
      )}

      {children}
    </div>
  );
};

export default PersonSummary;
